import { AppState } from "@Store/index";
import { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";

declare global {
  interface Window {
    isApp?: boolean;
    platform?: string;
  }
}

const useIsApp = () => {
  const { isApp } = useSelector(
    ({ appData }: AppState) => ({
      isApp: appData.isApp,
    }),
    shallowEqual,
  );
  // The native app injects `window.isApp = true` before content loads, so read
  // it synchronously on the first client render. This avoids an effect-driven
  // false -> true flip that briefly renders the non-app UI and causes a layout
  // shift. On the server (and in a normal browser) it falls back to the SSR value.
  const [isAmberApp, setIsAmberApp] = useState(
    () => isApp || (typeof window !== "undefined" && Boolean(window.isApp)),
  );

  useEffect(() => {
    if (isApp || (typeof window !== "undefined" && window.isApp)) {
      setIsAmberApp(true);
    }
  }, [isApp]);

  return isAmberApp;
};
// @ts-ignore
export const isApp = () => __CLIENT__ && (window.isApp || window?.__INITIAL_STATE__?.appData.isApp);
export const appOS: string = __CLIENT__ ? window.platform || "" : "";

export default useIsApp;
